import { render, staticRenderFns } from "./PlanUpgradeHost.vue?vue&type=template&id=0db4619f&"
import script from "./PlanUpgradeHost.vue?vue&type=script&lang=js&"
export * from "./PlanUpgradeHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports